<template>
  <div class="competition-container">
    <module1 />
    <module2 ref="competition2"/>
    <module3 ref="competition3" />
      <module5 ref="competition5"/>
    <module4 />
  </div>
</template>

<script>
import module1 from "./module1.vue";
import module2 from "./module2.vue";
import module3 from "./module3.vue";
import module4 from "./module4.vue";
import module5 from "./module5.vue";
import {EventBus} from "@/utils/bus";
import {handleScrollToForm} from "@/utils/scrollUtils";
export default {
  name: "CompetitionPage",
  components: {
    module1,
    module2,
    module3,
    module4,
      module5
  },data(){
        return{
            scrollTimeout: null
        }
    }
    ,methods:{

        getNavbarHeight() {
            const navElement = document.querySelector('nav');
            return navElement ? navElement.offsetHeight : 0;
        },
        getFullNavbarHeight() {
            // 获取主导航栏高度
            const navElement = document.querySelector('nav');
            // 获取顶部信息栏高度
            const infoBar = document.querySelector('.info-bar') || { offsetHeight: 0 };

            return (navElement?.offsetHeight || 0) + infoBar.offsetHeight;
        }
    },mounted() {
        EventBus.$on('scroll-to-competition', (sectionId) => handleScrollToForm(this,sectionId))
        if(this.$route.query.section){
            handleScrollToForm(this,this.$route.query.section);
        }
    },
    beforeDestroy() {
        // 移除监听器防止内存泄漏
        EventBus.$off('scroll-to-competition', handleScrollToForm)

    }
};
</script>

<style scoped>
.competition-container {
  display: flex;
  flex-direction: column;
}
</style>
